<style lang="scss" scoped>
.page_header {
  .button {
    padding: 0.35rem 0.75rem;
    height: 2rem;
  }

  .icon.is-small .mdi {
    font-size: 16px;
  }
}

.receipt_details .bill_tables .footer_table .table.leftside tr td[data-v-ac24c7a6]:nth-child(1) {
  width: 0;
}

.button.has-text-info {
  width: auto !important;
}

.msg_div {
  width: auto !important;
}

.modal_table {
  table,
  th,
  td {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    padding: 0.65rem 0.7rem;
    font-size: 1rem;
  }

  table {
    overflow-x: scroll;
    overflow-y: scroll;
  }

  td {
    display: table-cell;
    padding: 5px;
    color: black;
  }

  th {
    color: #fff;
    background-color: #56509f;
  }
}

</style>
<template>
  <div class="">
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="WOW Kit Order Process">
        <v-row>
          <v-col cols="8"
           sm="4" md="6" lg="4" style="position:absolute; top:0px; right:0;">
            <b-autocomplete
              v-model="searchKey"
              placeholder="franchisee name"
              :keep-first="keepFirst"
              :open-on-focus="true"
              :data="franchiseeData"
              field="companyName"
              icon="magnify"
              @select="option => (option ? selectFranchisee(option) : '')"
            >
              <template slot-scope="props">
                <div class="media">
                  <div class="media-content">

                    {{ props.option.companyName }}
                    <br />
                    <small> Email: {{ props.option.email }} </small>
                  </div>
                </div>
              </template>
            </b-autocomplete>
          </v-col>
        </v-row>
        <v-card-component v-if="selectedFranchisee != null">
          <v-simple-table>
            <template>
              <thead>
                <tr>
                  <th class="text-left">
                    Franchisee

                  </th>
                  <th class="text-left">
                    Center Type
                  </th>
                  <th class="text-left">
                    State
                  </th>
                  <th class="text-left">
                    Address
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ selectedFranchisee ? selectedFranchisee.companyName : '-' }}</td>
                  <td>{{ selectedFranchisee.franchiseeModel && selectedFranchisee.franchiseeModel.title ? selectedFranchisee.franchiseeModel.title : '-' }}</td>
                  <td>{{ selectedFranchisee.state || '-' }}</td>
                  <td>{{ selectedFranchisee.address1 || '-' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-component>
        <v-card flat class="px-2">
          <v-row>
            <!-- <v-col cols="12" md="4">
              <label class="body-2 font-weight-bold">Franchisee Category: </label>
              <v-autocomplete
                class="my-0 py-1"
                placeholder="--All Category--"
                required
                v-model.trim="filterObj.franchiseeModel"
                @change="filterProducts()"
                :items="franchiseeCategory"
                item-value="id"
                item-text="title"
              >
              </v-autocomplete>
            </v-col> -->
          <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-bold">Franchisee Category: </label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select required v-model.trim="filterObj.franchiseeModel" @change="filterProducts()">
                    <option value>----All Category----</option>
                    <option v-for="obj in franchiseeCategory" v-bind:key="obj.id" v-bind:value="obj.id"> {{ obj.title }}</option>
                  </select>
                </div>
              </div>
            </v-col>
            <!-- <v-col cols="12" md="4">
              <label class="body-2 font-weight-bold">Product Category: </label>
              <v-autocomplete class="my-0 py-1" placeholder="--All Category--" required v-model.trim="filterObj.productCategory" @change="filterProducts()"
                :items="productCategory" item-value="" item-text="obj">
              </v-autocomplete>
            </v-col> -->
            <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-bold">Product Category: </label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select required v-model.trim="filterObj.productCategory" @change="filterProducts()">
                    <option value>----All Category----</option>
                    <option v-for="obj in productCategory" v-bind:key="obj" v-bind:value="obj"> {{ obj }}</option>
                  </select>
                </div>
              </div>
          </v-col>

          <v-col cols="12" md="6" lg="4" >
              <div class="control">
               <v-btn class="mt-6" :disabled="selectedFranchisee == null" mediun color="primary" type="submit"  @click="uploadProductsModal = !uploadProductsModal">
                <v-icon left> mdi-upload </v-icon>upload Products</v-btn>
              </div>
            </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-list-item class="my-6" tile>
              <v-autocomplete
                key="id"
                label="Products"
                :items="productsArray"
                v-model="filterObj.productID"
                @change="filterProducts"
                required
                item-value="id"
                :hide-details="true"
              >
              </v-autocomplete>
            </v-list-item>
                <!-- <label class="body-2 font-weight-bold">Product</label>
              <div class="control">
                <div class="select is-fullwidth">
                 <select required v-model.trim="filterObj.productID" @change="filterProducts()">
                    <option value>----All Products----</option>
                    <option v-for="obj in productsArray" v-bind:key="obj" v-bind:value="obj"> {{ obj }}</option>
                  </select>
                </div> -->
                <!-- <b-autocomplete
              v-model="filterObj.productID"
              placeholder="franchisee name"
              :keep-first="keepFirst"
              :open-on-focus="true"
              :data="data"
              field="Product ID"
              icon="magnify"
              @select="option => option?filterProducts(option):filterProducts()"
            ><template slot-scope="props">
                      <div class="media">
                        <div class="media-content">
                          <p>{{ props.option.StickerName }}</p>
                          <small>productID: {{ props.option.productID }}</small>
                        </div>
                      </div>
                    </template>
                  </b-autocomplete> -->
                <!-- <b-field >
                  <b-autocomplete
                    v-model="filterObj.productID"
                    :open-on-focus="true"
                    :keep-first="keepFirst"
                    placeholder="Product ID"
                    :data="data"
                    field="StickerName"
                    icon="magnify"
                    @select="option => option?filterProducts(option):filterProducts()"
                    :disabled="!selectedFranchisee"
                  >
                    <template slot-scope="props">
                      <div class="media">
                        <div class="media-content">
                          <p>{{ props.option.StickerName }}</p>
                          <small>productID: {{ props.option.productID }}</small>
                        </div>
                      </div>
                    </template>
                  </b-autocomplete>
                </b-field> -->
              <!-- </div> -->
            </v-col>
                <v-col col="4" md="6" lg="4">
              <v-btn class="mt-6" mediun color="primary" type="submit" @click="clear()">
                <v-icon left> mdi-close </v-icon>Clear</v-btn>
                  </v-col>

          </v-row>
        </v-card>
        <div class="modal" :class="{ 'is-active': enableFilterModal }">
          <div class="modal-background"></div>
          <form class="modal-card  is-small">
            <header class="modal-card-head">
              <p class="modal-card-title"><strong> Wow Kit Order Filter</strong></p>
              <button class="delete" type="button" @click="enableFilterModal = false"></button>
            </header>
            <section class="modal-card-body">
              <form @submit.prevent="getProducts">
                <div class="columns">
                  <div class="field column is-6">
                    <b-field label="Franchisee">
                      <b-select placeholder="Select franchisee" expanded v-model="selectedFranchisee">
                        <option value>---Select---</option>
                        <option v-for="user in franchisees" v-bind:key="user.id" v-bind:value="user"> {{ user.companyName }}</option>
                      </b-select>
                    </b-field>
                  </div>
                </div>
                <hr />
                <div class="columns form-row">
                  <div class="column">
                    <button class="button is-success is-pulled-right" type="submit">Search</button>
                  </div>
                </div>
              </form>
            </section>
          </form>
        </div>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-spacer></v-spacer>
      <v-badge
        overlap
        :content="`${cartCount}`"
        color="pink"
      >
            <v-btn large elevation="1" @click="goToNext()" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="primary">
              Checkout
              <v-icon right>mdi-arrow-right-bold</v-icon>
            </v-btn>
      </v-badge>
          </v-card-text>

          <v-divider class=" my-0 " />
          <v-data-table
            :footer-props="{
              'items-per-page-options': [20,40,100]
            }"
            :items-per-page="40"
            :headers="headers"
            :items="products"
            :search="search"
            item-key="index"
          >
            <template v-slot:item.srNo="{ item }">
              <span>{{ item.i + 1 }}</span>
            </template>
            <template v-slot:item.productDetails="{ item }">
              <div class=" d-flex justify-center align-center">
                <img :src="'https://cdn.fcglcdn.com/brainbees/images/products/219x265/'
                + item.productID + 'a.jpg'" width="60" />
                <div class="ml-1">
                  <div class="caption">
                  Product ID: <span class="font-weight-medium">{{ item.productID }}</span>
                </div>
                <div class="caption">
                  <span class="font-weight-medium"></span>{{ item.productName }}</span>
                </div>
              </div>
              </div>
            </template>
            <template v-slot:item.productCategory="{ item }">
              <span>{{ item.productDetail.productCategory || '-' }}</span>
            </template>
            <template v-slot:item.quantity="{ item }">
              <div class="d-flex align-baseline justify-center">

                <v-btn elevation="2" :disabled="isCSVUpload"
                  color="grey lighten-4" x-small fab @click="changeProductQuantity('minus', item)">
                    <v-icon> mdi-minus </v-icon>
                  </v-btn>
                <v-text-field style="width:80px;" solo dense v-model="item.kitProductMaps.quantity" readonly class="centered-input mx-2 mt-5" ></v-text-field>
                  <v-btn elevation="2" :disabled="isCSVUpload" x-small fab color="grey lighten-4" @click="changeProductQuantity('plus', item)">
                    <v-icon>mdi-plus </v-icon>
                </v-btn>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <div>
                <v-btn :disabled="isCSVUpload" color="success" @click="addToCart(item)" v-show="!item.isAddedToCart">
                  <v-icon left>mdi-cart-plus</v-icon>
                  Add to Cart</v-btn
                >
              </div>
              <div>
                <v-btn :disabled="isCSVUpload" color="error" @click="removeProduct(item)" v-show="item.isAddedToCart">
                                    <v-icon left>mdi-close</v-icon>
                  Remove

                </v-btn>
              </div>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>

      <div class="modal" :class="{ 'is-active': uploadProductsModal }">
      <div class="modal-background"></div>
      <form class="modal-card" style="width:60rem;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <strong> Wow Kit Order - Products upload </strong>
          </p>
          <button class="delete" type="button" @click.prevent="closeFileUploadModal()"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="field">
              <div class="columns text-is-centered">
                <div class="column">
                    <v-file-input
                      accept=".csv"
                      v-model="dropFiles"
                      label="Drop your file here or click to upload"
                      @change="csvToJsonInput(dropFiles)"
                      ></v-file-input>
                </div>
                <div class="column">
                  <div class="field">
                    <div class="columns">
                      <div class="column has-text-centered">
                        <a class="button is-link" type="is-success" href="https://intellitots.s3.ap-south-1.amazonaws.com/wowKitProducts.csv" download>Download dummy file</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns is-mobile">
              <div class="column" v-if="jsonData.length > 0" style="overflow-x:scroll;">
               <div class="control">
                     <span align="center"><b>Total Products:- {{ productsCount||'-' }}</b></span>
                 </div>
                 <div class="control">
                     <span align="right"><b>Total Quantity:- {{ quantity|| '-' }}</b> </span>
                 </div>
                 <hr />
                <table class="modal_table">
                  <thead>
                    <th class="text-is-centered" v-for="head in Object.keys(jsonData[0])" :key="head">
                      {{ head }}
                    </th>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in jsonData" :key="index">
                      <td v-for="(data, head) in row" :key="head">
                        {{ data ? data.toString() : '-' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <footer class="modal-footer">
                  <div class="columns ">
                  <div class="col-md-6">
                    </div>
                  <div class="col-md-4">
                  <button class="button is-success is-pulled-right" type="button"
                   @click.prevent="validateFileData">
                   Add to cart</button>
                  </div>
                  <div class="col-md-2">
                <button class="button is-warning is-pulled-right"
                 type="button"
                  @click.prevent="closeFileUploadModal"
                  >
                   Close
                </button>
                </div>
                </div>
            </footer>
          </form>
        </section>
      </form>
    </div>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import stores from '@/stores'
import csvtojsonV2 from 'csvtojson'
import _ from 'lodash'
export default {
  name: 'wowKitOrderList',
  props: ['franchiseeID'],
  components: {
    VCardComponent,
    MaterialCard
  },
  data () {
    return {
      selectedFranchisee: '',
      cartCount: 0,
      franchisees: [],
      allWowKitProducts: [],
      tempProducts: [],
      categoryWiseProduct: [],
      keepFirst: false,
      viewFilterSec: true,
      enableFilterModal: false,
      uploadProductsModal: false,
      searchKey: '',
      data: [],
      quantity: null,
      productsCount: null,
      jsonData: [],
      isCSVUpload: false,
      dropFiles: null,
      isLoading: false,
      franchiseeCategory: [],
      search: '',
      productCategory: constants.productCategory,
      productsArray: [],
      filterObj: {
        franchiseeModel: '',
        productCategory: '',
        productID: ''
      },
      storesData: '',
      headers: [
        { text: 'Sr No', value: 'srNo' },
        { text: 'Product Details', align: 'center', value: 'productDetails' },
        { text: 'franchisee Category', align: 'center', value: 'franchiseeModel.title' },
        { text: 'Product Category', align: 'center', value: 'productCategory' },
        { text: 'Quantity', align: 'center', value: 'quantity' },
        { text: 'MRP', align: 'center', value: 'mrp' },
        { text: 'Margin (in %)', align: 'center', value: 'productDetail.retailerMargin' },
        { text: 'Actions', value: 'actions', align: 'center' }
      ]
    }
  },
  computed: {
    products: function () {
      this.tempProducts.forEach((p, i) => {
        p.i = i
        p.kitProductMaps.quantity = Number(p.kitProductMaps.quantity)
        p.productName = p.StickerName || '-'
        p.mrp = p.mrp || 0
      })
      return this.tempProducts
    },
    totalAmount: function () {
      let tempAmount = 0
      return this.products.reduce(function (sum, item) {
        tempAmount = Number(sum) + Number(item.totalPrice)
        return Number(tempAmount).toFixed(2)
      }, 0)
    },
    isPeginate: function () {
      if (this.products.length) {
        return true
      } else {
        return false
      }
    },
    cartItems: function () {
      if (this.data && this.data.length) {
        return this.data.filter(obj => obj.isAddedToCart === true)
      } else {
        return []
      }
    },
    franchiseeData: function () {
      return this.franchisees.filter(option => {
        return (
          option.companyName
            .toString()
            .toLowerCase()
            .indexOf(this.searchKey.toLowerCase()) >= 0 ||
          option.email
            .toString()
            .toLowerCase()
            .indexOf(this.searchKey.toLowerCase()) >= 0
        )
      })
    },

    cartLabel: function () {
      if (this.cartItems && this.cartItems.length > 0) {
        if (this.cartItems.length === 1) {
          return `View Cart (${this.cartItems.length} Item)`
        } else {
          return `View Cart (${this.cartItems.length} Items)`
        }
      } else {
        return `View Cart`
      }
    }
  },
  async created () {
    await this.getFranchisee()
    await this.getFranchiseeCategory()
    await this.onStart()
  },
  methods: {
    onStart: async function () {
      if (this.franchiseeID) {
        this.selectedFranchisee = this.franchisees.find(obj => obj.id === this.franchiseeID) || ''
      }
      if (this.selectedFranchisee && this.selectedFranchisee.id) {
        this.searchKey = this.selectedFranchisee.companyName
        const response = await stores.wowKitOrders.getWowKitOrders(this.selectedFranchisee.id)
        if (response) {
          this.selectedFranchisee.id = response.id
          if (!response.isCSVUpload) {
            this.storesData = response
            this.data = response.allProducts
            this.isCSVUpload = response.isCSVUpload
          }
        }
        if (stores.user.wowKitOrderItems.length !== 0) {
          this.selectedFranchisee.id = stores.user.wowKitOrderItems.id
          this.cartCount = Number(stores.user.wowKitOrderItems.cartCount)
        }
        await this.getProducts()
      } else {
        this.storesData = []
        this.selectedFranchisee = null
        this.data = []
      }
    },
    changeProductQuantity: function (type, item) {
      if (type === 'plus') {
        if (item.kitProductMaps.quantity < item.kitProductMaps.maxQuantity) {
          item.kitProductMaps.quantity = item.kitProductMaps.quantity + 1
          if (item.isAddedToCart === true) {
            if (Math.sign(this.cartCount)) { this.cartCount = Number(Number(this.cartCount) + 1) }
          }
        } else {
          item.kitProductMaps.quantity = item.kitProductMaps.maxQuantity
          return this.$dialog.info({
            text: 'You have reached maximum limit for ordering this product',
            title: 'Info'
          })
        }
      } else {
        if (item.kitProductMaps.quantity > item.kitProductMaps.minQuantity) {
          item.kitProductMaps.quantity = item.kitProductMaps.quantity - 1
          if (item.isAddedToCart === true) {
            if (Math.sign(this.cartCount)) {
              this.cartCount = Number(Number(this.cartCount) - 1)
            }
          }
        } else {
          item.kitProductMaps.quantity = item.kitProductMaps.minQuantity
          return this.$dialog.info({
            text: 'You have reached minimum limit for ordering this product',
            title: 'Info'
          })
        }
      }
    },
    onFranchiseeChange: async function () {
      await this.onStart()
    },

    getFranchisee: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.franchisees = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getFranchiseeCategory: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/models`)
        this.franchiseeCategory = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product category', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    goToNext: async function () {
      if (!this.cartItems.length) {
        return this.$dialog.error({
          text: 'Your Cart is empty!',
          title: 'Error'
        })
      }
      const cartProducts = _.map(this.cartItems, 'productID')
      if (_.uniq(cartProducts).length !== this.cartItems.length) {
        const duplicate = cartProducts.filter((v, i, a) => a.indexOf(v) !== i)

        return this.$dialog.error({
          text: `Duplicate product-[ ${duplicate.join(',')} ] added in the cart`,
          title: 'Error'
        })
      }
      const zeroQuantity = this.cartItems.filter(obj => obj.kitProductMaps.quantity <= 0)
      if (zeroQuantity.length) {
        let products = _.map(zeroQuantity, 'productID')
        return this.$dialog.error({
          text: `Cannot order product with 0 quantity-[ ${products.join(', ')}]`,
          title: 'Error'
        })
      }
      this.$dialog.confirm({
        text: 'Are you sure you want to place this order?',
        title: 'Confirm Order',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                if (!this.selectedFranchisee.b2bID) {
                  return this.$dialog.error({
                    text: 'Frnchisee b2bID is not available',
                    title: 'Error'
                  })
                }
                const wowkitObj = {
                  id: this.selectedFranchisee.id,
                  cartCount: this.cartCount,
                  b2bID: this.selectedFranchisee.b2bID,
                  modelID: this.selectedFranchisee.modelID,
                  email: this.selectedFranchisee.email,
                  allProducts: this.data,
                  products: this.cartItems,
                  totalAmount: 0,
                  isCSVUpload: this.isCSVUpload

                }
                await stores.wowKitOrders.addWowKitOrder(wowkitObj)
                this.$router.push({
                  name: 'wowKitOrderSummary',
                  params: {
                    franchiseeID: this.selectedFranchisee.id
                  }
                })
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
    },
    inputIsNumber: function () {
      Utils.isNumber()
    },
    getProducts: async function () {
      if (!this.selectedFranchisee.id) {
        this.tempProducts = []
        this.allWowKitProducts = []
        const errorMsg = 'Please Select Franchisee'
        return this.$dialog.error({
          text: errorMsg,
          title: 'Error'
        })
      }
      try {
        this.isLoading = true
        this.data = []
        this.tempProducts = []
        this.allWowKitProducts = []
        const { data } = await http.get(`${constants.API_URL}/api/kit-by-franchisee/${this.selectedFranchisee.id}`)
        this.enableFilterModal = false
        this.isLoading = false
        if (!data.length) {
          const errorMsg = 'No Kit Products are assign'
          return this.$dialog.error({
            text: errorMsg,
            title: 'Error'
          })
        }

        for (let object of data) {
          let products = object.kit.products
          for (let product of products) {
            let productData = Object.assign({}, {
              productID: product.productID,
              kitProductMaps: Object.assign({}, product.kitProductMaps || {}),
              hsncode: product.hsncode,
              mrp: product.mrp,
              productDetail: Object.assign({}, product.productDetail || {})
            })
            if (productData) {
              productData.franchiseeModel = object.franchiseeModel
              productData.isAddedToCart = false
              this.tempProducts.push(productData)
            }
          }
        }

        // productsArray = data[0].kitProductMap.kit.products
        // for (let object of data) {
        //   let product = productsArray.find(obj => obj.kitProductMaps.id === object.kitProductMapID)
        //   let productData = Object.assign({}, {
        //     productID: product.productID,
        //     kitProductMaps: Object.assign({}, product.kitProductMaps || {}),
        //     hsncode: product.hsncode,
        //     mrp: product.mrp,
        //     productDetail: Object.assign({}, product.productDetail || {})
        //   })
        //   if (productData) {
        //     productData.franchiseeModel = object.franchiseeModel
        //     productData.isAddedToCart = false
        //     this.tempProducts.push(productData)
        //   }
        // }
        if (!this.tempProducts.length) {
          const errorMsg = 'No Kit Products are assign'
          return this.$dialog.error({
            text: errorMsg,
            title: 'Error'
          })
        }
        // this.productsArray = this.tempProducts
        try {
          this.cartCount = 0
          if (stores.user.wowKitOrderItems && !stores.user.wowKitOrderItems.isCSVUpload) {
            if (this.selectedFranchisee && stores.user.wowKitOrderItems.id === this.selectedFranchisee.id) {
              this.tempProducts.forEach(tempE => {
                let result = _.find(stores.user.wowKitOrderItems.products, obj => obj.productID === tempE.productID && obj.franchiseeModel.id === tempE.franchiseeModel.id &&
                obj.franchiseeModel.title === tempE.franchiseeModel.title)
                if (result) {
                  tempE.isAddedToCart = true
                  this.cartCount = Number(this.cartCount) + Number(result.kitProductMaps.quantity)
                  tempE.kitProductMaps.quantity = result.kitProductMaps.quantity
                }
              })
            }
          }
        } catch (e) {
          console.log(e, 'error')
        }
        this.tempProducts = _.orderBy(this.tempProducts, [['isAddedToCart', 'DESC']])
        this.data = this.tempProducts
        this.allWowKitProducts = Object.assign(this.tempProducts, {})
        this.productsArray = _.uniq(_.map(this.data, 'productID'))
      } catch (e) {
        this.enableFilterModal = false
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in getting products getProducts() : ', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    selectFranchisee: function (franchisee) {
      if (franchisee) {
        this.isCSVUpload = false
        this.selectedFranchisee = franchisee
        this.getProducts()
      }
    },
    searchProduct: function (productObj) {
      if (!this.selectedFranchisee) {
        return this.$dialog.error({
          text: 'Please select franchisee',
          title: 'Error'
        })
      }
      let productExist = this.tempProducts.find(p => Number(p.productID) === Number(productObj.productID))
      if (productExist) {
        return this.$dialog.error({
          text: 'Product already added',
          title: 'Error'
        })
      }
      const Product = this.data.products.find(p => Number(p.productID) === Number(productObj.productID))
      if (Product) {
        this.tempProducts.push(Product)
        return this.$dialog.error({
          text: 'Product added',
          title: 'Error'
        })
      }
    },
    removeProduct: function (product) {
      let object = this.tempProducts.find(obj => obj.productID === product.productID && obj.franchiseeModel.id === product.franchiseeModel.id)
      object.isAddedToCart = false
      this.cartCount = this.cartCount - product.kitProductMaps.quantity
    },
    addToCart: function (product) {
      let object = this.tempProducts.find(obj => obj.productID === product.productID && obj.franchiseeModel.id === product.franchiseeModel.id)
      object.isAddedToCart = true
      this.cartCount = product.kitProductMaps.quantity + this.cartCount
    },
    filterProducts: function (key) {
      if (key && key.productID) {
        this.filterObj.productID = key.productID
      }
      this.tempProducts = this.data
      if (this.filterObj.franchiseeModel) {
        this.tempProducts = this.tempProducts.filter(obj => {
          return obj.franchiseeModel.id === this.filterObj.franchiseeModel
        })
      }
      if (this.filterObj.productCategory) {
        this.tempProducts = this.tempProducts.filter(obj => {
          return obj.productDetail.productCategory === this.filterObj.productCategory
        })
      }
      if (this.filterObj.productID) {
        this.tempProducts = this.tempProducts.filter(obj => {
          return obj.productID === this.filterObj.productID
        })
      }
      return this.tempProducts
    },
    closeFileUploadModal: function () {
      this.uploadProductsModal = false
      this.dropFiles = null
      this.productsCount = null
      this.quantity = null
      this.jsonData = []
    },
    validateFileData: async function () {
      try {
        if (!this.jsonData.length) {
          return this.showMessage('error', 'Please upload valid file')
        }
        this.isLoading = true
        let invalidProducts = []
        let invalidQuantity = []

        this.loadingComponent = this.$buefy.loading.open()
        for (let products of this.jsonData) {
          if (isNaN(products.productID)) {
            invalidProducts.push(products.productID)
          }
          if (isNaN(products.quantity) || products.quantity <= 0) {
            invalidQuantity.push(products.productID)
          }
        }
        let errorMessage = null
        if (invalidProducts.length) {
          errorMessage = `Invalid Products-${invalidProducts.join(', ')}`
        }
        if (invalidQuantity.length) {
          errorMessage = `${errorMessage || ''} <br/>
          Invalid Quantity-${invalidQuantity.join(', ')}`
        }
        let allProductID = this.jsonData.map(obj => obj.productID)
        const duplicateProducts = allProductID.filter((item, index) => allProductID.indexOf(item) !== index)
        if (duplicateProducts.length) {
          errorMessage = `${errorMessage || ''} <br/>
          Duplicate Products -${duplicateProducts.join(',')}`
        }
        if (errorMessage) {
          this.loadingComponent.close()
          return this.showMessage('error', errorMessage)
        }

        this.loadingComponent.close()
        this.$buefy.dialog.confirm({
          active: true,
          title: 'WOW Kit cart',
          message: 'Existing cart items will be removed!<br/> Do you want to proceed ?',
          confirmText: 'Proceed',
          cancelText: 'Cancel',
          type: 'is-warning',
          hasIcon: true,
          onConfirm: async () => {
            this.loadingComponent = this.$buefy.loading.open()
            this.tempProducts = Object.assign(this.allWowKitProducts, {})
            for (let product of this.tempProducts) {
              product.isAddedToCart = false
            }

            this.cartCount = 0
            if (this.tempProducts) {
              if (this.selectedFranchisee) {
                for (let tempE of this.jsonData) {
                  let result = _.find(this.tempProducts, obj => Number(obj.productID) === Number(tempE.productID))
                  if (!result) {
                    return this.showMessage('error', `Product not found- ${tempE.productID}`)
                  }
                  result.isAddedToCart = true
                  this.cartCount = Number(this.cartCount) + Number(tempE.quantity)
                  result.kitProductMaps.quantity = tempE.quantity
                }
              }
            }
            this.isCSVUpload = true
            this.tempProducts = _.orderBy(this.tempProducts, ['isAddedToCart'], ['desc'])
            let onlyCartProducts = []
            for (let i in this.tempProducts) {
              if (this.tempProducts[i].isAddedToCart === true) {
                onlyCartProducts.push(this.tempProducts[i])
              }
            }
            this.tempProducts = onlyCartProducts
            await this.closeFileUploadModal()
            this.loadingComponent.close()
          }
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.showMessage('error', errorMessage)
      }
    },
    readerFile: function (file, onLoadCallback) {
      var reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: async function (files) {
      try {
        this.jsonData = []
        this.loadingComponent = this.$buefy.loading.open()
        let self = this
        if (files.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = files

        this.readerFile(file, async e => {
          try {
            self.jsonData = await csvtojsonV2().fromString(e.target.result)
            if (!self.jsonData[0].productID || !self.jsonData[0].quantity) {
              self.jsonData = []
              self.dropFiles = null
              return this.$buefy.dialog.alert({
                type: 'is-danger',
                message: 'Invalid file or data of file!',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            if (self.jsonData.length) {
              this.productsCount = self.jsonData.length
              let allQuantity = self.jsonData.map(obj => obj.quantity)
              this.quantity = allQuantity.reduce((a, b) => Number(a) + Number(b), 0)
            }
          } catch (e) {
            self.jsonData = ''
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('e :', errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    showMessage: function (type, message) {
      return this.$dialog.info({
        text: message,
        title: type
      })
    },
    clear () {
      this.filterObj.productID = ''
      this.getProducts()
    }
  }
}
</script>

<style lang="css" scoped>
.confirmBtn {
  position: absolute;
  bottom: 0.65rem;
}
</style>
<style lang="scss" scoped>
.hr_yellow {
  background-color: #191d38;
  height: 0.3rem;
}
</style>
